import { FormerMemberInvestmentTaxForms } from '../../../../former-member/components/FormerMemberInvestmentTaxForms';

export default function FormerMemberInvestmentTaxFormsPage() {
    return <FormerMemberInvestmentTaxForms />;
}
